import React from 'react';
//import stickyNoteImage from '../../../../../../_assets/images/theming/StickyNote.png'; // Adjust the path based on your directory structure

interface DashStickyNoteProps {
  title: string;
  content: string;
}

const DashStickyNote: React.FC<DashStickyNoteProps> = ({ title, content}) => {
  return (
    <div
      style={{
        //backgroundImage: `url(${stickyNoteImage})`,
        backgroundSize: '80% 80%', // Adjust this value based on your needs ('cover', 'contain', or '100% 100%')
        backgroundRepeat: 'no-repeat', // Prevents the image from repeating
        backgroundPosition: 'center', // Keeps the image centered
        width: '200px',  // Adjust to your desired width
        height: '150px', // Adjust to your desired height
        padding: '10px',
        //border:'black thick',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        //boxShadow: '2px 2px 5px rgba(0, 0, 0, 0.2)',
        //borderRadius: '5px',
        color: '#333',
        
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      <div style={{ fontSize: '1rem', fontWeight: 'bold', textAlign: 'center' }}>
        {title}
      </div>
      <div style={{ fontSize: '0.9rem', textAlign: 'center', flexGrow: 1 }}>
        {content}
      </div>
      <div style={{ fontSize: '0.8rem', textAlign: 'right', fontWeight: 'bold', color: '#d35400' }}>
        
      </div>
    </div>
  );
};

export default DashStickyNote;